import FormType from "../../Components/Form2/FormType";
import image10 from "../../Assets/Images/location_two.png";

const RouterLocationFormOptions = (init = {}) => {
	return {
		Fields: [
			{
				element: FormType.Input,
				name: "routerLocationDescription",
				label: "Router Location Description",
				placeholder: "e.g. Living Room, Server Room",
				value: init.routerLocationDescription || "",
				required: true,
				info: "Provide a short description of where the router will be placed.",
				infoImage: image10,
			},
			{
				element: FormType.FileUpload,
				name: "routerLocationImage",
				label: "Router Location (Photo)",
				description:
					"Choose a secure and central location within your premises for placing the Starlink router.",
				value: init.routerLocationImage || [],
				required: true,
				fileTypes: "image",
			},
			{
				element: FormType.CheckBoxList,
				name: "routerStorageAvailable",
				label: "Do you have where to store the router?",
				options: [
					{ label: "Yes", value: "yes" },
					{ label: "No", value: "no" },
				],
				value: init.routerStorageAvailable || "",
				required: true,
			},
			{
				element: FormType.CheckBoxList,
				name: "drillingRequired",
				label: "Is there any drilling/wall penetration required?",
				options: [
					{ label: "Yes", value: "yes" },
					{ label: "No", value: "no" },
				],
				value: init.drillingRequired || "",
				required: true,
			},
			{
				element: FormType.CheckBox,
				name: "acknowledge",
				label:
					"I acknowledge that inaccurate information may result in extra charges.",
				value: !!init.acknowledge,
				required: true,
				changeEvent: true,
			},
		],
	};
};

export default RouterLocationFormOptions;
